import { FlexProps, useColorModeValue } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import React from 'react';

type FilterBarContainerProps = {
  children: React.ReactNode;
};

export const FilterBarContainer: React.FC<
  FilterBarContainerProps & FlexProps
> = ({ children, ...props }) => {
  const bgColor = useColorModeValue(
    'background.light.highest',
    'background.dark.lowest',
  );

  return (
    <Flex
      px="28px"
      direction="row"
      alignItems={'center'}
      justifyContent="flex-between"
      background={bgColor}
      zIndex="1"
      borderBottomWidth="thin"
      position="relative"
      {...props}>
      {children}
    </Flex>
  );
};
